import ProfileImgModal from "./ImageModal";
export default ProfileImgModal;